export const SET_PAYMENTS_LOADING_BRAINTREE = 'SET_PAYMENTS_LOADING_BRAINTREE';
export const SET_PAYMENTS_BRAINTREE_ERROR = 'SET_PAYMENTS_BRAINTREE_ERROR';
export const SET_PAYMENTS_BRAINTREE_WARNING = 'SET_PAYMENTS_BRAINTREE_WARNING';
export const SET_PAYMENTS_BRAINTREE_CLIENT_TOKEN = 'SET_PAYMENTS_BRAINTREE_CLIENT_TOKEN';
export const SET_PAYMENTS_REDIRECT_HCID = 'SET_PAYMENTS_REDIRECT_HCID';
export const SET_PAYMENTS_FETCHING_HC = 'SET_PAYMENTS_FETCHING_HC';
export const SET_PAYMENTS_HC_ERROR = 'SET_PAYMENTS_HC_ERROR';
export const SET_PAYMENTS_HC_INFO = 'SET_PAYMENTS_HC_INFO';
